/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { LoginViewModel } from "../types/LoginViewModel.ts";

export const loginViewModelSchema = z.object({
  user: z
    .string()
    .min(1)
    .describe("Nome de usuário ou e-mail para autenticação."),
  password: z.string().min(1).describe("Senha do usuário."),
  accessType: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo de acesso utilizado na autenticação. Enum EUserAccessType: `0` = Web, `1` = Mobile, `2` = Integration.",
      ),
  ),
  companyId: z
    .number()
    .int()
    .describe(
      "ID da empresa para autenticação no contexto de uma empresa específica. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<LoginViewModel>;
